import { FC, PropsWithChildren } from 'react';
import { Layout } from '@repo/atomic-components';
import { Header } from './Header';

// Mirrors UserManagementTemplate's frame — a 48px Header row lifted above any
// page overlays, then a single scrollable content row on the pale grey app
// background. The dashboard owns its own inner padding / max-width.
export const GlobalAdminDashboardTemplate: FC<PropsWithChildren> = ({ children }) => {
  return (
    <Layout>
      <div className="bg-fletchers-gray-25 grid h-full w-full grid-cols-[minmax(0,1fr)] grid-rows-[48px_1fr] gap-0">
        <div className="relative z-[1102] col-span-full">
          <Header />
        </div>
        <div className="col-span-full h-full w-full overflow-y-auto">{children}</div>
      </div>
    </Layout>
  );
};
